import React, { useEffect, useState } from 'react'
import Header from '../components/Header'
import BottomNavbar from '../components/BottomNavbar';
import { useLocation, useNavigate } from 'react-router-dom';
import classes from "./QuizDetails.module.css";
import { FaArrowLeft } from "react-icons/fa6";
import { levels as defaultLevels } from '../utils/levels';
import { getQuizDetails } from '../http/http';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { removeUserToken } from '../store/slices/userTokenSlice';
import { imageBaseUrl } from '../utils/constants';

const QuizDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [levels, setLevels] = useState(defaultLevels);
  const [quiz, setQuiz] = useState(location?.state);
  const [quizLevel, setQuizLevel] = useState(levels[0]);
  const { userToken } = useSelector(state => state.persisted.userTokenSlice);
  const [loading, setLoading] = useState(true);
  const { selectedLanguage } = useSelector(state => state.languageSlice);
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleQuizClick = (quizValue, quizLevelValue) => {
    setQuiz(quizValue);
    setQuizLevel(quizLevelValue);
  };

  useEffect(() => {
    if (location?.state) {
      setLoading(true);
      setQuiz(location?.state)
      const levelPromises = defaultLevels.map((level) => getQuizDetails(location.state?.id, level.id, selectedLanguage, userToken));
      Promise.all(levelPromises).then(res => {
        setLevels(res?.map((quiz, index) => ({ ...defaultLevels[index], questions: quiz.length, points: quiz.length * defaultLevels[index].perQuestion })));
        setQuizLevel({
          ...defaultLevels[0], questions: res[0]?.length, points: res[0]?.length * defaultLevels[0].perQuestion
        })
      }).catch(error => {
        if (error?.response?.status == 403) {
          dispatch(removeUserToken());
          navigate('/');
        }
      });
      setLoading(false);
    }
    else {
      navigate(-1);
    }
  }, [location?.state]);

  return (
    <>
      <Header hideLanguage={true} />

      <div className={classes.container}>

        <div className={classes.header_section}>
          <div className={classes.back_button} onClick={() => {
            navigate(-1);
          }}>
            <FaArrowLeft className={classes.back_icon} />
          </div>

          <h2 className={classes.header_quiz_text}>{quiz?.name}</h2>


        </div>


        <div className={classes.quiz_image_container}>
          <div className={classes.quiz_image_wrapper}>
            <img
            src={quiz?.image ? `${imageBaseUrl}${quiz?.image}` : "/assets/images/download.png"}
             alt={quiz?.name} className={classes.quiz_image} />
          </div>
        </div>

        <p className={classes.quiz_title}>
          {location?.state?.name} {t("8")}
        </p>

        <div className={classes.quiz_questions_container}>
          <div className={classes.question_image_icon_container}>
            <img src='/assets/images/question.png' alt={t("9")} className={classes.question_image_icon} />
          </div>
          <p className={classes.question_text}>{quizLevel?.questions} {t("9")}</p>
        </div>

        <div className={classes.quiz_description_container}>

          <p className={classes.quiz_description_title}>
            {t("10")}
          </p>

          <p className={classes.quiz_description}>{location?.state?.description}</p>
        </div>

        <div className={classes.quiz_description_container}>

          <p className={classes.quiz_description_title}>
            {t("11")}
          </p>

          <div className={classes.levels_container}>
            <div className={`${classes.level_container} ${quizLevel?.id == "1" && classes.beginner_active}`}
              onClick={() => handleQuizClick(location?.state, levels[0])}
            >
              <div className={classes.level_sub_container}>
                <div className={classes.level_info}>
                  <img src="/assets/images/Beginner.png" alt="beginner level" className={classes.level_img} />
                  <p className={classes.level_text}>{t("12")}</p>
                </div>
                <div className={`${classes.points_badge} ${classes.beginner}`}>
                  <p className={classes.points}>{levels[0].points} {t("13")}</p>
                </div>
              </div>
            </div>

            <div className={`${classes.level_container} ${quizLevel?.id == "2" && classes.intermediate_active}`}
              onClick={() => handleQuizClick(location?.state, levels[1])}
            >
              <div className={classes.level_sub_container}>
                <div className={classes.level_info}>
                  <img src="/assets/images/Intermediate.png" alt="intermediate level" className={classes.level_img} />
                  <p className={classes.level_text}>{t("14")}</p>
                </div>
                <div className={`${classes.points_badge} ${classes.intermediate}`}>
                  <p className={classes.points}>{levels[1].points} {t("13")}</p>
                </div>
              </div>
            </div>

            <div className={`${classes.level_container} ${quizLevel?.id == "3" && classes.advance_active}`}
              onClick={() => handleQuizClick(location?.state, levels[2])}

            >
              <div className={classes.level_sub_container}>
                <div className={classes.level_info}>
                  <img src="/assets/images/Advance.png" alt="advance level" className={classes.level_img} />
                  <p className={classes.level_text}>{t("15")}</p>
                </div>
                <div className={`${classes.points_badge} ${classes.advance}`}>
                  <p className={classes.points}>{levels[2].points} {t("13")}</p>
                </div>
              </div>
            </div>

          </div>


        </div>

        <button className={`${classes.play_button} ${(!quizLevel?.questions || quizLevel?.questions <= 0) && classes.disabled}`} type='button'
          onClick={() => {
            navigate("/finding-opponent", {
              state: {
                qid: location?.state, level: quizLevel
              }
            })
          }}
          disabled={!quizLevel?.questions || quizLevel?.questions <= 0}
        >
          {t("181")}
        </button>



      </div >

      <BottomNavbar active={null} />

    </>
  )
}

export default QuizDetails;